// api.js
export const Api = _gTheme_.apiUrl + '/graphql';
export const urlAssets =  _gTheme_.apiUrl;

const locale = (document.documentElement.lang || 'en').split('_')[0].split('-')[0];
const supportedLocales = ['it', 'en', 'es', 'de', 'fr'];
const finalLocale = supportedLocales.includes(locale) ? locale : 'en';

export { finalLocale as locale };


export const SlugCommercialFilter = 'commercial-sites';
export const SlugApplicationFilter = 'applications';
